module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-12.faa3c770.jpg";